import type { MutableRefObject } from 'react';

type TNode = { children: Array<{ type: string; value: string }>; depth: number; type: string };

const extractHeading = (node: TNode) => {
    if (node.type === 'heading' && node.depth === 2) {
        return node.children
            .filter(child => child.type === 'text')
            .map(child => child.value)
            .join('');
    }
};

export const remarkPlugin =
    ({ headingsRef }: { headingsRef: MutableRefObject<string[]> }) =>
    (tree: { children: TNode[] }) => {
        tree.children.forEach(node => {
            const heading = extractHeading(node);
            if (heading && !headingsRef.current.includes(heading))
                headingsRef.current.push(heading);
        });
    };
